require('../../modules/es6.object.set-prototype-of');

module.exports = require('../../modules/_core').Object.setPrototypeOf;